
export interface _Object {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
}

export interface StateCity {
  label: string;
  cities: string[];
}

export interface StateCityMap {
  [key: string]: StateCity;
}

export interface SessionState {
  isUserLoggedIn?: boolean,
  token?: object,
  loggedInUser?: { [key: string]: number | string },
  alerts?: { [key: string]: number | string },
}

export const getAcronym = (inputString: string) => {
  if (inputString) {
    const words = inputString?.split(' ');
    const acronym = words.map(word => word.charAt(0).toUpperCase()).join('');
    return acronym;
  }
};

export const showTostify = (ref: any, type: any, message: string) => {
  if (type === 'success') {
    ref.current?.show({ severity: 'success', summary: 'Success', detail: message || 'Login successful!', life: 4000 });
  } else {
    ref.current?.show({ severity: 'error', summary: 'Error', detail: message || 'Login failed', life: 3000 });
  }
}

export const generateQueryParams = (args: any) => {
  let str = ''
  let replace = ''
  for (const key in args) {
    if (typeof (args[key]) === 'object') {
      for (const key1 in args[key]) {
        str += `&filters[${key1}]=${args[key][key1]}`
        replace = str.slice(1)
      }
    } else {
      str += `&${key}=${args[key]}`
      replace = str.slice(1)
    }
  }
  return replace
}

export const getStatusLabel = (status: string) => {
  switch (status) {
    case 'active':
      return 'Active'
    case 'pending':
      return 'Pending'
    case 'published':
      return 'Published'
    case 'hidden':
      return 'Hidden'
  }
}